const LAUNCHER_BOTTOM_VARIABLE = '--intercom-launcher-bottom';

class IntercomService {
  initialize() {
    if (window && window.Intercom) {
      window.Intercom('boot', {
        app_id: 'c201wqyu',
      });
      console.log('Intercom initialized');
    }
  }

  // Lifts the chat launcher above a fixed bar at the bottom of the page
  // (see GlobalStyle); the lightweight launcher ignores `vertical_padding`.
  setLauncherBottom(px) {
    document.documentElement.style.setProperty(
      LAUNCHER_BOTTOM_VARIABLE,
      `${px}px`
    );
  }

  resetLauncherBottom() {
    document.documentElement.style.removeProperty(LAUNCHER_BOTTOM_VARIABLE);
  }
}

export const intercomService = new IntercomService();
